import { createContext, useContext, useId } from 'react'
import styles from './Tooltip.module.scss'

/** @type {import('./Tooltip.types').TooltipContext} */
// @ts-expect-error null init
const TooltipContext = createContext(null)

const useTooltipContext = () => useContext(TooltipContext)

/** @param {import('./Tooltip.types').TooltipProps} props */
export const Tooltip = ({ children }) => {
  const id = useId()

  return (
    <TooltipContext.Provider value={{ id }}>
      <div className={styles.tooltip}>{children}</div>
    </TooltipContext.Provider>
  )
}

/** @param {import('./Tooltip.types').TooltipTriggerProps} props */
export const TooltipTrigger = ({ children }) => {
  const { id } = useTooltipContext()
  if (!id) throw new Error('TooltipTrigger must be used within Tooltip')

  return (
    <span className={styles.tooltipTrigger} aria-describedby={id}>
      {children}
    </span>
  )
}

/** @param {import('./Tooltip.types').TooltipContentProps} props */
export const TooltipContent = ({ children, ...props }) => {
  const { id } = useTooltipContext()
  if (!id) throw new Error('TooltipContent must be used within Tooltip')

  return (
    <div className={styles.tooltipContent} role='tooltip' id={id} {...props}>
      <span className={styles.tooltipContentArrow}></span>
      {children}
    </div>
  )
}
